module.exports = __webpack_public_path__ + "img/straight-rail-horizontal-backplates-remnants.8316d5ef.png";